import { Tabs } from 'antd'
import React from 'react'
import SlotCards from './SlotCards'
import SlotList from './SlotList'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import { t } from 'i18next'
import dayjs from 'dayjs'

export default function PatientSlotsTab ({ patientSlots, boxes }) {
  const screens = useBreakpoint()

  const ongoingSlot = (slot) => (
    ['clean_in_progress', 'late', 'in_progress'].includes(slot.state)
  )

  const nearSlot = (slot) => (
    slot.state === 'waiting' && dayjs(slot.begin_date) <= dayjs().add(1, 'hour')
  )

  const nextSlot = (slot) => (
    slot.state === 'waiting' && dayjs(slot.begin_date) > dayjs().add(1, 'hour')
  )

  const canceledSlot = (slot) => (
    slot.state === 'auto_cancel' || slot.state === 'cancel'
  )

  const currentSlotTab = (slots) => {
    return displayedSlots(slots.filter((slot) => ongoingSlot(slot) || nearSlot(slot)))
  }

  const nextSlotsTab = (slots) => {
    return displayedSlots(slots.filter((slot) => nextSlot(slot)))
  }

  const canceledSlotsTab = (slots) => {
    return displayedSlots(slots.filter((slot) => canceledSlot(slot)))
  }

  const allPatientSlots = (slots) => {
    return displayedSlots(slots)
  }

  const displayedSlots = (slots) => {
    if (screens.xs) {
      return <SlotCards slots={slots} boxes={boxes} />
    } else {
      return <SlotList slots={slots} boxes={boxes} />
    }
  }

  return (
    <Tabs
      defaultActiveKey='current'
      items={[
        {
          label: t('Admin.SlotsPage.tab.currentPatientSlots'),
          key: 'current',
          children: currentSlotTab(patientSlots)
        },
        {
          label: t('Admin.SlotsPage.tab.nextPatientSlots'),
          key: 'next',
          children: nextSlotsTab(patientSlots)
        },
        {
          label: t('Admin.SlotsPage.tab.canceledPatientSlots'),
          key: 'canceled',
          children: canceledSlotsTab(patientSlots)
        },
        {
          label: t('Admin.SlotsPage.tab.allPatientSlots'),
          key: 'allPatientSlots',
          children: allPatientSlots(patientSlots)
        }
      ]}
    />
  )
}
